import React from 'react'
import Input from './Input'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive'
import { useTranslation } from 'react-i18next'
import { currencySymbol } from '../../domain/types'

const PromoCodesInput: React.FC<{
  value: string | undefined
  onChange?: (value: any) => void
  onClick: () => void
  disabled?: boolean
  buttonSize?: 'medium' | 'large'
  discountValue: number | null | undefined
  discountUsedSuccesfully: boolean | undefined
  currency: string | undefined
}> = ({
  value,
  onChange,
  disabled = false,
  onClick,
  buttonSize = 'large',
  discountValue,
  discountUsedSuccesfully,
  currency,
}) => {
  //
  const { t } = useTranslation()
  //
  return (
    <Wrapper>
      <Title>{`${t('usePromoCode')}`}</Title>

      <InputLabel>{t('enterPromoCode')}</InputLabel>

      <Content $buttonSize={buttonSize}>
        <Input
          id="promo-codes-input"
          label=""
          // label={`${t('enterPromoCode')}`}
          value={value}
          onChange={(value) => onChange?.(value)}
          disabled={disabled}
          width="fullWidth"
        />
        <Button $clearBtn={discountUsedSuccesfully} $buttonSize={buttonSize} onClick={onClick}>
          <span>{discountUsedSuccesfully ? `${t('cleanUp')}` : `${t('applyNow')}`}</span>
        </Button>
      </Content>

      {discountValue && discountValue !== null && discountValue > 0 ? (
        <TextSpan>
          {`${t('discount')}:`} {discountValue} {currencySymbol(currency)}
        </TextSpan>
      ) : null}
    </Wrapper>
  )
}

const InputLabel = styled.label`
  width: inherit;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 5px;
  text-align: left;
  padding-right: 25px;
  color: ${Colors.primaryGrey};
`

const Button = styled.button<{ $buttonSize: 'medium' | 'large'; $clearBtn: boolean | undefined }>`
  border: 1px solid ${Colors.primaryBlack};
  outline: none;
  user-select: none;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: ${({ $clearBtn }) => ($clearBtn === true ? 'transparent' : Colors.primaryBlack)};
  height: 48px;
  width: 100%;
  span {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    color: ${({ $clearBtn }) => ($clearBtn === true ? Colors.primaryBlack : Colors.white)};
  }

  ${Responsive.mobile} {
    span {
      font-size: 14px;
    }
  }
`

const TextSpan = styled.span`
  color: ${Colors.primaryGreen};
  font-size: 14px;
  margin-top: 9px;
  font-weight: 500;
`

const Content = styled.div<{ $buttonSize: 'medium' | 'large' }>`
  display: grid;
  grid-template-columns: 1fr 217px;
  grid-template-columns: ${({ $buttonSize }) => ($buttonSize === 'large' ? '1fr 217px' : '1fr 175px')};
  gap: 20px;
  align-items: flex-end;

  ${Responsive.mobile} {
    gap: 16px;
    grid-template-columns: 1fr 137px;
  }
`

const Title = styled.h1`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 24px;

  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 14px;
  }
`

const Wrapper = styled.div``
export default PromoCodesInput
